import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, KeepAlive as _KeepAlive } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_metainfo = _resolveComponent("metainfo")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_fa = _resolveComponent("fa")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_item_divider = _resolveComponent("ion-item-divider")!
  const _component_ion_menu_toggle = _resolveComponent("ion-menu-toggle")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_menu = _resolveComponent("ion-menu")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_ion_router_outlet = _resolveComponent("ion-router-outlet")!
  const _component_ion_split_pane = _resolveComponent("ion-split-pane")!
  const _component_ion_app = _resolveComponent("ion-app")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_metainfo, null, {
      title: _withCtx(({ content }) => [
        _createTextVNode(_toDisplayString(content ? `${content} | JuraNews` : `JuraNews`), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_ion_app, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_split_pane, { "content-id": "main" }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_menu, {
              side: "start",
              "content-id": "main",
              type: "overlay"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_header, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_toolbar, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_title, null, {
                          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                            _createTextVNode("Menu", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_content, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_list, { id: "menu-list" }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuItems, (p, i) => {
                          return (_openBlock(), _createBlock(_component_ion_menu_toggle, {
                            "auto-hide": "false",
                            key: i
                          }, {
                            default: _withCtx(() => [
                              (p && p.visible)
                                ? (_openBlock(), _createBlock(_component_ion_item, {
                                    key: 0,
                                    lines: "none",
                                    onClick: ($event: any) => (_ctx.action(p.routePath, p.event)),
                                    class: "fas fa-users"
                                  }, {
                                    default: _withCtx(() => [
                                      (p.icon)
                                        ? (_openBlock(), _createBlock(_component_ion_icon, {
                                            key: 0,
                                            slot: "start",
                                            name: p.icon
                                          }, null, 8, ["name"]))
                                        : _createCommentVNode("", true),
                                      (p.faIcon)
                                        ? (_openBlock(), _createBlock(_component_fa, {
                                            key: 1,
                                            style: {"font-size":"24px","opacity":"0.6"},
                                            slot: "start",
                                            class: "icon-inner ionicon s-ion-icon",
                                            icon: p.faIcon
                                          }, null, 8, ["icon"]))
                                        : _createCommentVNode("", true),
                                      _createVNode(_component_ion_label, { class: "pl-0 pl-0" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(p.name), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                : _createCommentVNode("", true),
                              (p.divider)
                                ? (_openBlock(), _createBlock(_component_ion_item_divider, { key: 1 }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_col, { size: "1" }),
                    _createVNode(_component_ion_col, { size: "5" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_text, { color: "secondary text-right pl-10 ion-text-start" }, {
                          default: _withCtx(() => [
                            _createElementVNode("p", null, "v" + _toDisplayString(_ctx.version) + _toDisplayString(_ctx.environment), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_col, { size: "6" })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ion_router_outlet, { id: "main" }, {
              default: _withCtx(() => [
                (_openBlock(), _createBlock(_KeepAlive, { include: "ChatComponent" }, [
                  _createVNode(_component_router_view, null, {
                    default: _withCtx(({ Component }) => [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                    ]),
                    _: 1
                  })
                ], 1024))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}